import React from 'react';
import Products from 'components/features/Products/Products';

const DrumsPage = () => (
  <>
    <Products category="drums" />
  </>
);

export default DrumsPage;
